const pledgeListDevelopment = [
  {
    id: 5,
    user_id: 5,
    campaign_name: "کمپین بنری روپلاک کاسپین ۱۴۰۱",
    amount: 115646,
    status: "گرفته شده",
    created_at: "1401/08/04 10:06:51",
  },
  {
    id: 4,
    user_id: 5,
    campaign_name: "کمپین بنری روز مرد ۱۴۰۰",
    amount: 383333,
    status: "پس داده شده",
    returned_at: "1400/11/29",
    created_at: "1400/11/23 10:06:51",
  },
  {
    id: 3,
    user_id: 4,
    campaign_name: "کمپین بنری روز زن ۱۴۰۰",
    amount: 310831,
    status: "پس داده شده",
    returned_at: "1400/11/05",
    created_at: "1400/10/30 15:36:28",
  },
  {
    id: 2,
    user_id: 4,
    campaign_name: "کمپین بنری عید فطر ۱۴۰۰",
    amount: 143333,
    status: "پس داده شده",
    returned_at: "1400/02/27",
    created_at: "1400/06/20 20:50:00",
  },
  {
    id: 1,
    user_id: 4,
    campaign_name: "کمپین بنری عید نوروز ۱۴۰۰",
    amount: 2450543,
    status: "پس داده شده",
    returned_at: "1400/01/21",
    created_at: "1399/12/27 10:50:25",
  },
];

const pledgeListProduction = [
  {
    id: 5,
    user_id: 5,
    campaign_name: "کمپین بنری روپلاک کاسپین ۱۴۰۱",
    amount: 115646,
    status: "گرفته شده",
    created_at: "1401/08/04 10:06:51",
  },
  {
    id: 4,
    user_id: 5,
    campaign_name: "کمپین بنری روز مرد ۱۴۰۰",
    amount: 383333,
    status: "پس داده شده",
    returned_at: "1400/11/23",
    created_at: "1400/11/23 10:06:51",
  },
  {
    id: 3,
    user_id: 4,
    campaign_name: "کمپین بنری روز زن ۱۴۰۰",
    amount: 310831,
    status: "پس داده شده",
    returned_at: "1400/10/30",
    created_at: "1400/10/30 15:36:28",
  },
  {
    id: 2,
    user_id: 4,
    campaign_name: "کمپین بنری عید فطر ۱۴۰۰",
    amount: 143333,
    status: "پس داده شده",
    returned_at: "1400/11/04",
    created_at: "1400/10/30 20:50:00",
  },
  {
    id: 1,
    user_id: 4,
    campaign_name: "کمپین بنری عید نوروز ۱۴۰۰",
    amount: 2450543,
    status: "پس داده شده",
    returned_at: "1400/01/21",
    created_at: "1399/12/27 10:50:25",
  },
];

const getPledgeList = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return pledgeListProduction;
  }
  return pledgeListDevelopment;
};

export default getPledgeList();
